import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  constructor() {}

  formatDatetime(date: Date, format: string) {
    const padStart = (value: number): string =>
      value.toString().padStart(2, '0');
    return format
      .replace(/yyyy/g, padStart(date.getFullYear()))
      .replace(/dd/g, padStart(date.getDate()))
      .replace(/mm/g, padStart(date.getMonth() + 1))
      .replace(/hh/g, padStart(date.getHours()))
      .replace(/ii/g, padStart(date.getMinutes()))
      .replace(/ss/g, padStart(date.getSeconds()));
  }

  formatUTCDatetime(date: Date, format: string) {
    const padStart = (value: number): string =>
      value.toString().padStart(2, '0');
    return format
      .replace(/yyyy/g, padStart(date.getUTCFullYear()))
      .replace(/dd/g, padStart(date.getUTCDate()))
      .replace(/mm/g, padStart(date.getUTCMonth() + 1))
      .replace(/hh/g, padStart(date.getUTCHours()))
      .replace(/ii/g, padStart(date.getUTCMinutes()))
      .replace(/ss/g, padStart(date.getUTCSeconds()));
  }
}
